var render, staticRenderFns
import script from "./DisputeStatusView.vue?vue&type=script&lang=js"
export * from "./DisputeStatusView.vue?vue&type=script&lang=js"
import style0 from "./DisputeStatusView.vue?vue&type=style&index=0&id=a0afad4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0afad4e",
  null
  
)

export default component.exports